import React, { useState, useEffect } from 'react';
import { t } from '../utils/translations.js';

const ContactHub = () => {
  const [copied, setCopied] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const contactMethods = [
    {
      id: 'email',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="5" width="18" height="14" rx="2.5"></rect>
          <path d="M4 7l8 6 8-6"></path>
        </svg>
      ),
      title: t('contact.email_title', 'João Garcia Miguel'),
      value: 'garcia@joaogarciamiguel.com',
      href: 'mailto:garcia@joaogarciamiguel.com',
      copyable: true
    },
    {
      id: 'phone',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 4.5h3l1.5 4-2 1.7a14.4 14.4 0 0 0 6.3 6.3l1.7-2 4 1.5v3a2 2 0 0 1-2.2 2A17.6 17.6 0 0 1 3 6.7 2 2 0 0 1 5 4.5z"></path>
        </svg>
      ),
      title: t('contact.call_title', 'Give Us a Call'),
      value: '+351 933 326 207',
      href: 'tel:+351933326207',
      copyable: true
    },
    {
      id: 'location',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 21s-6.5-5.8-6.5-11A6.5 6.5 0 1 1 18.5 10c0 5.2-6.5 11-6.5 11z"></path>
          <circle cx="12" cy="10" r="2.5"></circle>
        </svg>
      ),
      title: t('contact.office_title', 'Arenes'),
      value: 'R. Brg. Miranda Palha 16, Torres Vedras',
      href: 'https://www.google.com/maps/search/?api=1&query=Arenes+-+Centre+for+Contemporary+Theatre,+Torres+Vedras',
      copyable: false
    }
  ];

  const handleCopy = async (text, id) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(id);
      setTimeout(() => setCopied(null), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="contact-hub-react">
      <style>{`
        .contact-hub-react {
          max-width: 1100px;
          margin: 4rem auto;
          padding: 0 2rem;
          font-family: var(--font-primary, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
          --ch-surface: var(--color-bg-secondary, #f9fafb);
          --ch-elevated: var(--color-bg-primary, #ffffff);
          --ch-border: var(--color-border-light, #e5e7eb);
          --ch-text: var(--color-text-primary, #1f2937);
          --ch-muted: var(--color-text-secondary, #6b7280);
          --ch-primary: var(--primary-color, #6d28d9);
          --ch-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
          --ch-shadow-hover: 0 20px 40px rgba(0, 0, 0, 0.18);
        }

        [data-theme="dark"] .contact-hub-react {
          --ch-surface: #1e293b;
          --ch-elevated: #273449;
          --ch-border: rgba(203, 213, 225, 0.26);
          --ch-text: #f8fafc;
          --ch-muted: #dbe4f0;
          --ch-primary: #c4b5fd;
          --ch-shadow: 0 10px 24px rgba(2, 6, 23, 0.26);
          --ch-shadow-hover: 0 14px 30px rgba(2, 6, 23, 0.32);
        }

        [data-theme="dark"] .contact-hub-card {
          background: linear-gradient(180deg, rgba(30, 41, 59, 0.9) 0%, rgba(30, 41, 59, 0.82) 100%);
          -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
        }

        [data-theme="dark"] .contact-hub-card:hover {
          background: linear-gradient(180deg, rgba(39, 52, 73, 0.94) 0%, rgba(39, 52, 73, 0.88) 100%);
        }

        .contact-hub-header {
          text-align: center;
          margin-bottom: 3rem;
          opacity: 0;
          transform: translateY(20px);
          animation: fadeInUp 0.6s ease forwards;
        }

        .contact-hub-subtitle {
          font-size: 0.9rem;
          font-weight: 700;
          color: var(--ch-primary);
          letter-spacing: 0.05em;
          text-transform: uppercase;
          margin: 0 0 0.75rem 0;
          display: block;
        }

        .contact-hub-title {
          font-family: var(--font-display, 'Inter', sans-serif);
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 800;
          color: var(--ch-text);
          letter-spacing: -0.02em;
          margin: 0;
          line-height: 1.1;
        }

        .contact-hub-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2rem;
        }

        .contact-hub-card {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 1.5rem;
          padding: 2.5rem;
          border: 1px solid var(--ch-border);
          border-radius: 16px;
          text-decoration: none;
          color: var(--ch-muted);
          background-color: var(--ch-surface);
          box-shadow: var(--ch-shadow);
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          opacity: 0;
          transform: translateY(30px);
          animation: fadeInUp 0.6s ease forwards;
          cursor: pointer;
        }

        .contact-hub-card:nth-child(1) { animation-delay: 0.1s; }
        .contact-hub-card:nth-child(2) { animation-delay: 0.2s; }
        .contact-hub-card:nth-child(3) { animation-delay: 0.3s; }

        .contact-hub-card:hover {
          transform: translateY(-8px);
          box-shadow: var(--ch-shadow-hover);
          border-color: var(--ch-primary);
          background-color: var(--ch-elevated);
        }

        .contact-hub-icon {
          position: relative;
          color: var(--ch-primary);
          background: transparent;
          border: 0;
          width: auto;
          height: auto;
          border-radius: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
        }

        .contact-hub-icon::after {
          display: none;
        }

        .contact-hub-icon svg {
          width: 32px;
          height: 32px;
          stroke-width: 1.75;
          fill: none !important;
          stroke: currentColor !important;
          vector-effect: non-scaling-stroke;
          transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), stroke 0.25s ease;
        }

        .contact-hub-icon svg * {
          fill: none !important;
          stroke: currentColor !important;
        }

        .contact-hub-card:hover .contact-hub-icon {
          transform: translateY(-1px) scale(1.04);
          background: transparent;
          color: var(--ch-primary);
          box-shadow: none;
        }

        [data-theme="light"] .contact-hub-icon {
          background: transparent;
          color: #4f5ff0;
        }

        [data-theme="light"] .contact-hub-icon svg,
        [data-theme="light"] .contact-hub-icon svg * {
          fill: none !important;
          stroke: currentColor !important;
        }

        [data-theme="light"] .contact-hub-card:hover .contact-hub-icon {
          background: transparent;
          color: #4f5ff0;
          box-shadow: none;
        }

        .contact-hub-card:hover .contact-hub-icon svg {
          transform: scale(1.03);
        }

        .contact-hub-text h4 {
          font-family: var(--font-display, 'Inter', sans-serif);
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--ch-text);
          margin: 0 0 0.5rem 0;
          line-height: 1.3;
        }

        .contact-hub-text p {
          font-size: 1rem;
          color: var(--ch-muted);
          word-break: break-word;
          margin: 0;
          line-height: 1.5;
        }

        .contact-copy-btn {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: var(--ch-primary);
          color: var(--color-bg-primary, #ffffff);
          border: none;
          border-radius: 8px;
          padding: 0.5rem;
          cursor: pointer;
          opacity: 0;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
        }

        .contact-hub-card:hover .contact-copy-btn {
          opacity: 1;
        }

        .contact-copy-btn:hover {
          transform: scale(1.05);
        }

        .contact-copy-btn.copied {
          background: #10b981;
        }

        .map-section-container {
          max-width: 1100px;
          margin: 5rem auto 0 auto;
          padding: 0 2rem;
          opacity: 0;
          animation: fadeInUp 0.6s ease 0.5s forwards;
        }

        .map-section-header {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .map-divider {
          flex-grow: 1;
          height: 1px;
          background-color: var(--ch-border);
        }

        .map-title {
          font-size: 0.9rem;
          font-weight: 600;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: var(--ch-muted);
          margin: 0;
        }

        .map-embed-wrapper {
          width: 100%;
          height: 450px;
          border-radius: 16px;
          overflow: hidden;
          border: 1px solid var(--ch-border);
          background: var(--ch-elevated);
          box-shadow: var(--ch-shadow);
          transition: all 0.3s ease;
        }

        .map-embed-wrapper:hover {
          box-shadow: var(--ch-shadow-hover);
          transform: translateY(-2px);
        }

        .map-embed-wrapper iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }

        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .contact-hub-react,
          .map-section-container {
            padding: 0 1.5rem;
            margin-top: 2rem;
          }

          .contact-hub-card {
            flex-direction: row;
            text-align: left;
            padding: 1.5rem;
          }

          .contact-hub-icon {
            width: auto;
            height: auto;
          }

          .map-embed-wrapper {
            height: 350px;
          }
        }
      `}</style>

      <div className="contact-hub-header">
        <span className="contact-hub-subtitle">{t('contact.subtitle', '[ Let\'s Talk ]')}</span>
        <h2 className="contact-hub-title">{t('contact.title', 'Olá, tudo bem?')}</h2>
      </div>

      <div className="contact-hub-grid">
        {contactMethods.map((method) => (
          <a
            key={method.id}
            href={method.href}
            className="contact-hub-card"
            target={method.id === 'location' ? '_blank' : undefined}
            rel={method.id === 'location' ? 'noopener noreferrer' : undefined}
            onClick={(e) => {
              if (method.copyable && e.shiftKey) {
                e.preventDefault();
                handleCopy(method.value, method.id);
              }
            }}
          >
            {method.copyable && (
              <button
                className={`contact-copy-btn ${copied === method.id ? 'copied' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleCopy(method.value, method.id);
                }}
              >
                {copied === method.id ? t('contact.copied', 'Copied') : t('contact.copy', 'Copy')}
              </button>
            )}
            <div className="contact-hub-icon">{method.icon}</div>
            <div className="contact-hub-text">
              <h4>{method.title}</h4>
              <p>{method.value}</p>
            </div>
          </a>
        ))}
      </div>

      <div className="map-section-container">
        <div className="map-section-header">
          <span className="map-divider"></span>
          <h2 className="map-title">{t('contact.map_title', 'ARENES')}</h2>
          <span className="map-divider"></span>
        </div>
        <div className="map-embed-wrapper">
          <iframe
            src="https://maps.google.com/maps?q=Arenes%20-%20Centre%20for%20Contemporary%20Theatre%2C%20Torres%20Vedras&t=&z=15&ie=UTF8&iwloc=&output=embed"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="ARENES Location Map"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactHub;
